<div class="container-fluid">
    <div *ngIf="loading"> loading ...</div>
    <button *ngFor="let attr of filteredAttributes; let i = index" type="button" class="btn btn-outline-primary btn-sm ms-2"  
        [ngClass]="attr['code'] === projection ? 'active': 'pdf-exclude'"   (click)="activeProject(attr['code'])" >
        {{ attr['label']}}
    </button>
    <app-ncs-chart [ngStyle]="{ 'min-height': '300px' }" [chartType]="chartType" [data]="chartdata"
        [options]="chartOptions" *ngIf="!loading">
    </app-ncs-chart>
</div>